import React from "react";
import { ReactComponent as ActionSvg } from "@/assets/images/desktop/opciones.svg";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
	<a
		href=" "
		ref={ref}
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
	>
		{children}
		<ActionSvg style={{ marginRight: "7px", marginTop: "3px" }} />
	</a>
));

export default CustomToggle;
